<template>
  <div class="home-body-wrapper">
    <div v-if="activeName == 1">
      <!-- 挂载HomeBodyFirst组件 -->
      <HomeBodyFirst :activeFenleiName="activeFenleiName" @categoryClick="handleCategoryClick" />
      <!-- 挂载HomeBodySecond组件 -->
      <HomeBodySecond :activeFenleiName="String(activeFenleiName)"
        @activeNameSecondClick="handleActiveNameSecondClick" />
      <!-- 挂载HomeBodyThird组件 -->
      <HomeBodyThird />
      <!-- 挂载HomeBodyFourth组件 -->
      <HomeBodyFourth />
    </div>

    <div v-if="activeName == 2 || activeName == 5 || activeName == 6">
      <!-- 挂载SupplyHall组件 -->
      <SupplyHall :fenleObj="fenleObj" :keyword="keyword" />
    </div>
    <div v-if="activeName == 3">
      <!-- 挂载PurchaseHall组件 -->
      <ProcurementHall />
    </div>
    <div v-if="activeName == 4">
      <!-- 挂载Market组件 -->
      <Market />
    </div>
    <div v-if="activeName == 7">
      <!-- 挂载Market组件 -->
      <Xuetang />
    </div>
    <div v-if="activeName == 8">
      <!-- 挂载Market组件 -->
      <ShopTuiguang />
    </div>

    <!-- 右侧悬浮按钮 -->
    <div class="floating-buttons">
      <!-- 聊生意按钮 -->
      <div class="floating-btn business-btn" @click="goMessage">
        <div class="btn-icon">
          <img src="../assets/images/19.png" alt="聊生意" v-if="businessIcon">
          <!-- <span class="icon-placeholder">💬</span> -->
        </div>
        <div class="btn-text">聊生意</div>
      </div>

      <!-- 在线客服按钮 -->
      <div class="floating-btn service-btn" @click="openServiceDialog">
        <div class="btn-icon">
          <img src="../assets/images/20.png" alt="在线客服" v-if="serviceIcon">
          <!-- <span class="icon-placeholder">👨‍💻</span> -->
        </div>
        <div class="btn-text">在线客服</div>
      </div>

      <!-- 回顶部按钮 -->
      <div class="floating-btn back-top-btn" @click="scrollToTop">
        <div class="btn-icon">
          <img src="../assets/images/21.png" alt="回顶部" v-if="backTopIcon">
          <!-- <span class="icon-placeholder">↑</span> -->
        </div>
        <div class="btn-text">回顶部</div>
      </div>
    </div>

    <!-- 在线客服弹框 -->
    <el-dialog title="在线客服" :visible.sync="serviceDialogVisible" width="400px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="service-dialog-content">
        <div class="service-avatar">
          <img src="../assets/images/75.png" alt="客服" v-if="serviceIcon" />
          <div class="avatar-placeholder" v-else>
            <!-- <span class="icon-placeholder">👨‍💻</span> -->
          </div>
        </div>
        <div class="service-phone">{{ servicePhone }}</div>
        <div class="service-time">工作时间 {{ workTime }}</div>
        <!-- <el-button type="primary" class="call-button" @click="closeServiceDialog">
          拨打电话
        </el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入HomeBodyFirst组件
import HomeBodyFirst from '../components/HomeBody/HomeBodyFirst.vue'
// 导入HomeBodySecond组件
import HomeBodySecond from '../components/HomeBody/HomeBodySecond.vue'
// 导入HomeBodyThird组件
import HomeBodyThird from '../components/HomeBody/HomeBodyThird.vue'
// 导入HomeBodyFourth组件
import HomeBodyFourth from '../components/HomeBody/HomeBodyFourth.vue'
// 导入SupplyHall组件
import SupplyHall from '../components/SupplyHall/SupplyHall.vue'
// 导入PurchaseHall组件
import ProcurementHall from '../components/ProcurementHall/ProcurementHall.vue'
// 导入Market组件
import Market from '../components/Market/Market.vue'
// 导入Xuetang组件
import Xuetang from '../components/HomeBody/HomeBodyFourth.vue'
// 导入ShopTuiguang组件
import ShopTuiguang from '../components/ShopTuiguang/ShopTuiguang.vue'
import { ensureGoEasyConnected } from '@/utils/goeasy'



export default {
  name: 'HomeBody',
  components: {
    // 注册HomeBodyFirst组件
    HomeBodyFirst,
    // 注册HomeBodySecond组件
    HomeBodySecond,
    // 注册HomeBodyThird组件
    HomeBodyThird,
    // 注册HomeBodyFourth组件
    HomeBodyFourth,
    // 注册SupplyHall组件
    SupplyHall,
    // 注册PurchaseHall组件
    ProcurementHall,
    // 注册Market组件
    Market,
    // 注册Xuetang组件
    Xuetang,
    // 注册ShopTuiguang组件
    ShopTuiguang,
  },
  props: {
    activeName: {
      type: [String, Number],
      default: ''
    },
    activeFenleiName: {
      type: [String, Number],
      default: ''
    },
    keyword: {
      type: String,
      default: ''
    },
  },

  mounted() {
    this.getServicePhone();
  },

  data() {
    return {
      // 图标是否加载成功的标志
      businessIcon: true,
      serviceIcon: true,
      backTopIcon: true,
      fenleObj: {},
      // 客服弹框控制
      serviceDialogVisible: false,
      // 客服电话
      servicePhone: '',
      workTime: ''
    }
  },
  methods: {
    // 跳转 GoEasy 聊天列表（聊生意）
    async goMessage() {
      // 判断是否已登录
      if (!this.$store.getters.isLoggedIn) {
        this.$message.warning('请先登录')
        this.$router.push('/login')
        return
      }
      // 已登录：确保 GoEasy 连接（断线则重连）
      const connected = await ensureGoEasyConnected(this.$store.getters.getUserInfo)
      if (!connected) {
        this.$message.error('聊天服务连接失败，请稍后重试')
        return
      }
      this.$router.push('/message')
    },
    // 回顶部方法
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    // 处理分类点击事件
    handleCategoryClick(e) {
      console.log(e, 'eee');
      this.fenleObj = e
      this.$emit('activeName_change', '2')

    },
    handleActiveNameSecondClick(e) {
      this.$emit('activeName_change', '2')
    },
    // 打开客服弹框
    openServiceDialog() {
      this.serviceDialogVisible = true;
    },
    // 关闭客服弹框
    closeServiceDialog() {
      this.serviceDialogVisible = false;
    },

    // 获取客服电话
    getServicePhone() {
      this.$api.getSystemParams().then(res => {
        this.servicePhone = res.tel || '';
        this.workTime = res.time || '';
      }).catch(err => {
        console.error('获取收货地址列表失败:', err);
        this.$message.error(err);
      })
    }
  }
}
</script>

<style scoped>
.home-body-wrapper {
  width: 100%;
  position: relative;
  /* 为悬浮按钮提供定位参考 */
}

/* 右侧悬浮按钮容器 */
.floating-buttons {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;
  /* 确保按钮在最上层 */
}

/* 悬浮按钮样式 */
.floating-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 10px;
}

.floating-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  background-color: #f8f9fa;
}

/* 在线客服弹框样式 */
.service-dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
}

.service-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #f0f8ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  overflow: hidden;
}

.service-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
}

.service-phone {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.service-time {
  font-size: 14px;
  color: #666;
  margin-bottom: 40px;
}

.call-button {
  width: 280px;
  height: 50px;
  font-size: 16px;
  background-color: #286CED;
  border: none;
  border-radius: 25px;
}

.call-button:hover {
  background-color: #1e5bd8;
}

/* 按钮图标 */
.btn-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.btn-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 图标占位符 */
.icon-placeholder {
  font-size: 20px;
}

/* 按钮文字 */
.btn-text {
  font-size: 12px;
  color: #333333;
  text-align: center;
}

/* 聊生意按钮特殊样式 */
.business-btn .btn-icon {
  position: relative;
}

.business-btn .btn-icon::after {
  content: '';
  position: absolute;
  top: -2px;
  right: -2px;
  width: 10px;
  height: 10px;
  background-color: #ff4757;
  border-radius: 50%;
  border: 2px solid #ffffff;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .floating-buttons {
    right: 10px;
  }

  .floating-btn {
    width: 60px;
    height: 60px;
  }

  .btn-icon {
    width: 24px;
    height: 24px;
  }

  .btn-text {
    font-size: 11px;
  }
}
</style>